import { useContext, useEffect, useState } from 'react'
import { BiTrophy } from 'react-icons/bi'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { listarRecompensas } from '../../services/recompensa'
import { RecompensaResposta } from '../../interfaces/recompensa'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import Organizacao from '../../middleware/Organizacao'
import Permissao from '../../middleware/Permissoes'
import '../../styles/menuopcoes.css'

function MenuOpcoesConquistas(props: menuOpcoes) {
    const { atualizarInformacoes } = useContext(ModalEstadoContext)

    const [subMenu, setSubMenu] = useState(false)
    const [recompensas, setRecompensas] = useState(0)

    function exibirSubmenu() {
        setSubMenu(subMenu => !subMenu)
    }


    useEffect(() => {
        const buscarRecompensas = async () => {
            try {

                const resposta = await listarRecompensas({ titulo: "", situacao: "", pagina: 1 })

                setRecompensas(resposta.data.filter((recompensa: RecompensaResposta)=> ["Em Análise", "Preparando"].includes(recompensa.situacao)).length)
                
            } catch {
                return
            }
        }
        buscarRecompensas()
    }, [atualizarInformacoes])

    return (
        <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
            <Permissao permissoes={['master', 'conquistas_acesso']}>
                <div>
                    <div id='menuOpcoes' onClick={exibirSubmenu}>
                        <BiTrophy id='iconeMenu' color='#F1F1F3' />
                        <p id='tituloMenu'>{props.titulo}</p>
                        {recompensas !== 0 ? <h2>{recompensas}</h2> : null}
                    </div>
                    <div id='submenuOpcoes'>
                        <Permissao permissoes={['master', 'conquistas_conquista']}>
                            {subMenu && <SubMenuOpcoes redirect='/conquistas' texto='Conquistas' />}
                        </Permissao>
                        <Permissao permissoes={['master', 'conquistas_recompensa']}>
                            {subMenu && <SubMenuOpcoes redirect='/recompensas' texto='Recompensas' notificacao={recompensas === 0 ? null : recompensas} />}
                        </Permissao>
                    </div>
                </div>
            </Permissao>
        </Organizacao>
    )
}

export default MenuOpcoesConquistas